import { useTranslations } from 'next-intl';
import { Button } from '@/app/components/ui/button';
import { Dialog, DialogContent } from '@/app/components/ui/dialog';

interface UserInfoDialogProps {
  title: string;
  description: string;
  open: boolean;
  onChange: () => void;
  setOpen: (open: boolean) => void;
  loading?: boolean;
  closeOnConfirm?: boolean;
}

export const UserInfoDialog = ({
  open,
  onChange,
  setOpen,
  title,
  description,
  loading = false,
  closeOnConfirm = true,
}: UserInfoDialogProps) => {
  const t = useTranslations();

  const handleConfirm = () => {
    onChange();
    if (closeOnConfirm) setOpen(false);
  };

  return (
    <Dialog open={open} onOpenChange={() => setOpen(false)}>
      <DialogContent className="w-[642px]" onClose={() => setOpen(false)} disableOverlayClose={true}>
        <div className="font-medium text-system-text01 text-xl">{title}</div>
        <div className="text-sm text-white">{description}</div>
        <div className="pointer-events-none flex justify-end gap-4 sm:w-full md:mt-0">
          <Button
            onClick={() => setOpen(false)}
            variant="outline"
            className="pointer-events-auto h-9 px-[45px] py-[6px] text-sm"
            disabled={loading}
          >
            {t('create.createForm.upload.cancel')}
          </Button>
          <Button
            onClick={handleConfirm}
            variant="primary"
            className="pointer-events-auto h-9 px-[45px] py-[6px] text-sm"
            disabled={loading}
            loading={loading}
          >
            {t('create.createForm.upload.confirm')}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
